import { GieliCoordinates, TileCoordinates, TileRectangle } from "../../../lib/runescape/coordinates";
import { Rectangle } from "../../../lib/math";
import { ClueProperties } from "./ClueProperties";
import { MapEntity } from "../../../lib/gamemap/MapEntity";
import { blue_marker, green_marker, red_marker, yellow_marker } from "../../../lib/gamemap/GameMap";
import * as leaflet from "leaflet";
import { TileArea } from "../../../lib/runescape/coordinates/TileArea";
export class ClueOverviewMarker extends MapEntity {
    constructor(clue, methods, edit_handler, talk_alternative_index) {
        super();
        this.clue = clue;
        this.methods = methods;
        this.edit_handler = edit_handler;
        this.talk_alternative_index = talk_alternative_index;
        this.setInteractive();
        this.setTooltip(async () => {
            let self = this;
            return (await new ClueProperties(self.clue, self.edit_handler, true, self.talk_alternative_index).rendered()).row(c().text("Right click marker to manage methods.").css("font-style", "italic"));
        });
    }
    bounds() {
        return TileRectangle.from(ClueOverviewMarker.position(this.clue, this.talk_alternative_index));
    }
    async render_implementation(options) {
        //let marker = new TileMarker(ClueOverviewMarker.position(this.clue, this.talk_alternative_index)).withMarker().addTo(this)
        const level_markers = [red_marker, blue_marker, green_marker, yellow_marker];
        const pos = ClueOverviewMarker.position(this.clue, this.talk_alternative_index);
        const highlight = options.highlight;
        let marker = leaflet.marker([pos.y, pos.x], {
            icon: leaflet.icon({
                iconUrl: level_markers[pos.level],
                iconSize: highlight ? [27, 36] : [18, 24],
                iconAnchor: highlight ? [14, 36] : [9, 24],
                className: "marker-icon",
            }),
        }).addTo(this);
        return marker.getElement();
    }
    async contextMenu(event) {
        return await ClueProperties.methodMenu(this.clue, this.edit_handler);
    }
}
(function (ClueOverviewMarker) {
    function position(clue, alternative_index) {
        switch (clue.clue.type) {
            case "anagram":
            case "simple":
            case "cryptic":
            case "map":
                switch (clue.clue.solution?.type) {
                    case "talkto":
                        let i = Math.min(alternative_index || 0, clue.clue.solution.spots.length);
                        return TileArea.activate(clue.clue.solution.spots[i].range).center();
                    case "dig":
                        return clue.clue.solution.spot;
                    case "search":
                        return TileRectangle.center(clue.clue.solution.spot);
                }
                return { x: 0, y: 0, level: 0 };
            case "compass":
                return clue.spot;
            case "coordinates":
                return GieliCoordinates.toCoords(clue.clue.coordinates);
            case "emote":
                return TileArea.activate(clue.clue.area).center();
            case "scan":
                return TileCoordinates.lift(Rectangle.center(Rectangle.from(...clue.clue.spots)), Math.min(...clue.clue.spots.map(s => s.level)));
            case "skilling":
                let i = alternative_index || 0;
                if (i >= 0 && clue.clue.areas?.length > 0) {
                    if (i >= clue.clue.areas.length)
                        i = 0;
                    return TileArea.activate(clue.clue.areas[i]).center();
                }
                break;
        }
        return { x: 0, y: 0, level: 0 };
    }
    ClueOverviewMarker.position = position;
    function forClue(spot, method_index, edit_handler) {
        let variants = (() => {
            if (spot.clue.solution?.type == "talkto" && spot.clue.solution.spots) {
                return spot.clue.solution.spots.map((s, i) => ({ instance_index: i }));
            }
            else if (spot.clue.type == "skilling") {
                return (spot.clue.areas || []).map((s, i) => ({ instance_index: i }));
            }
            else
                return [{}];
        })();
        return variants.map(({ instance_index }) => new ClueOverviewMarker(spot, method_index, edit_handler, instance_index));
    }
    ClueOverviewMarker.forClue = forClue;
})(ClueOverviewMarker || (ClueOverviewMarker = {}));
